(function () {
  // Click-to-zoom lightbox for RTE images opted in via [data-st-zoom].
  // Managed by .scripts/73-profiling-poster-lightbox.mjs. Builds its overlay
  // lazily on first use and acts on nothing until a [data-st-zoom] is clicked,
  // so pages without such images are entirely unaffected.
  var overlay, imgEl, closeBtn, lastFocus;

  function build() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'st-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.hidden = true;
    overlay.innerHTML =
      '<button type="button" class="st-lightbox__close" aria-label="Close">&times;</button>' +
      '<img class="st-lightbox__img" alt="">';
    imgEl = overlay.querySelector('.st-lightbox__img');
    closeBtn = overlay.querySelector('.st-lightbox__close');
    // Close on backdrop / close-button / the image itself (image is cursor:zoom-out).
    overlay.addEventListener('click', close);
    document.body.appendChild(overlay);
  }

  function open(src, alt) {
    if (!src) return;
    build();
    imgEl.src = src;
    imgEl.alt = alt || '';
    overlay.setAttribute('aria-label', alt || 'Expanded image');
    lastFocus = document.activeElement;
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function close() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    imgEl.removeAttribute('src');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function srcOf(el) {
    // <img>: full file URL (currentSrc handles srcset). Non-img opt-ins may
    // carry the URL on data-st-zoom-src.
    return el.getAttribute('data-st-zoom-src') || el.currentSrc || el.src || '';
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-st-zoom]');
    if (!el) return;
    e.preventDefault();
    open(srcOf(el), el.getAttribute('alt'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-st-zoom]')) {
      e.preventDefault();
      open(srcOf(e.target), e.target.getAttribute('alt'));
    }
  });
})();
